import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { MenuItem } from 'primereact/menuitem';

export const MasterTab = (mainTabLabel: any) => {
    const router = useNavigate();
    const assignedMenu: any = localStorage.getItem('assigned_menu') ? localStorage.getItem('assigned_menu') : '';

    const HRitems: MenuItem[] = [
        {
            label: 'Application Bill Master',
            command: () => {
                router('/app/application-bill-master');
            }
        },
        {
            label: 'Application Master',
            command: () => {
                router('/app/application-master');
            }
        },
        {
            label: 'Approval Master',
            command: () => {
                router('/app/approval');
            }
        },
        {
            label: 'Board Master',
            command: () => {
                router('/app/board-master');
            }
        },
        {
            label: 'College Entry',
            command: () => {
                router('/app/college-entry');
            }
        },
        {
            label: 'Council Master',
            command: () => {
                router('/app/council-master');
            }
        },
        {
            label: 'Document Master',
            command: () => {
                router('/app/document-master');
            }
        },
        {
            label: 'Exam Authority',
            command: () => {
                router('/app/exam-authority');
            }
        },
        {
            label: 'Hospital Master',
            command: () => {
                router('/app/hospital-master');
            }
        },

        {
            label: 'Other Master',
            command: () => {
                router('/app/other-master');
            }
        },
        {
            label: 'University Master',
            command: () => {
                router('/app/university-master');
            }
        },
        {
            label: 'User Bind / Email Update / Password Update',
            command: () => {
                router('/app/user-update');
            }
        }
    ];

    const [activeIndex, setActiveIndex] = useState<number>(0);

    // Convert string to Set
    const assignedMenuSet = new Set(assignedMenu.split(',').map((item: string) => item.trim()));

    // Filter HRitems by checking if label exists in assignedMenuSet
    const filteredHRitems = HRitems.filter((item) => item.label && assignedMenuSet.has(item.label));

    useEffect(() => {
        if (filteredHRitems.length > 0 && mainTabLabel) {
            const foundIndex = filteredHRitems.findIndex((item) => item.label == mainTabLabel.mainTabLabel);
            setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
        }
    }, [filteredHRitems]);

    return (
        <>
            <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab" />
        </>
    );
};
